import Highcharts, {
  AxisLabelsFormatterContextObject,
  SeriesOptionsType,
  XAxisOptions,
} from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { getScanHexColor } from 'lib/health-readings';
import { ColorRange, ParameterHistory } from 'services/face-scan/type';

const LineChart = ({
  colorRanges,
  data,
}: {
  data: ParameterHistory[];
  colorRanges: ColorRange[];
}) => {
  const options: Highcharts.Options = {
    chart: {
      type: 'spline',
      height: '160px',
    },
    title: {
      text: '',
    },
    legend: {
      enabled: false,
    },
    tooltip: {
      borderWidth: 0,
      backgroundColor: 'rgba(255, 255, 255, 0)',
      formatter: function () {
        const pointColor = this.point.color || '#000000';
        const bgColor = Highcharts.color(pointColor).setOpacity(0.85).get();

        return (
          `<div style="background-color:${bgColor}; border: 1px solid ${pointColor}; border-radius: 5px; padding: 8px; color: #333; color: #fff; font-weight: 600; font-family: Isidora sans;">` +
          `Value: ${this.y}<br/>${this.x}` +
          `</div>`
        );
      },
      useHTML: true,
    },
    xAxis: {
      categories: data.map((point) => point.custom_number),

      tickWidth: 1,
      tickmarkPlacement: 'on',
      tickPositions: [0, data.length - 1],
      tickColor: '#10A4B1',
      tickLength: 10,
      tickPosition: 'outside',

      minPadding: 0.5,
      maxPadding: 0.5,

      labels: {
        style: {
          color: '#10A4B1',
        },
        formatter: function (this: AxisLabelsFormatterContextObject) {
          if (this.isFirst || this.isLast) {
            return this.value;
          } else {
            return '';
          }
        },
        overflow: 'justify',
      },
    } as XAxisOptions,
    yAxis: {
      title: {
        text: null,
      },
      visible: false,
      plotBands: colorRanges.map((range) => ({
        from: Array.isArray(range.range)
          ? (range.range[0] as number)
          : -Infinity,
        to: Array.isArray(range.range) ? (range.range[1] as number) : Infinity,
        color: range.color,
        borderWidth: 0,
      })),
    },
    series: [
      {
        name: 'Value',
        data: data.map((point) => ({
          y: +point.avg_value,
          marker: {
            enabled: true,
            states: {
              hover: {
                enabled: true,
                radius: 6,
              },
            },
          },
          color: getScanHexColor(+point.avg_value, colorRanges).color || '#000',
        })),
        zones: colorRanges.map((range) => ({
          value: Array.isArray(range.range)
            ? (range.range[1] as number)
            : range.range[0] === '<3.01'
            ? 3.01
            : Infinity,
          color: range.color,
        })),
        zoneAxis: 'y',
        pointPlacement: 'on',
      } as SeriesOptionsType,
    ],
    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 500,
          },
          chartOptions: {
            legend: {
              layout: 'horizontal',
              align: 'center',
              verticalAlign: 'bottom',
            },
          },
        },
      ],
    },
  };

  return (
    <HighchartsReact
      highcharts={Highcharts}
      options={options}
      containerProps={{ style: { width: '100%', height: '160px' } }}
    />
  );
};

export default LineChart;
